'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path')

module.exports = {
  version: {
    client:'2.4.4',
    internal:'2.4.4.6'
  },
  dev: {

    // Paths
    assetsSubDirectory: 'static-portal',
    assetsPublicPath: '/',
    proxyTable: {
      '/api':{                                // 后端服务接口 启用
        // target:'http://192.168.1.56:3000',   // 开发地址
        // target:'http://192.168.1.105:3000',   // 开发地址
        target:'http://www.cfbrain.cn',   // 演示环境地址
        changeOrigin:true,                            // 允许跨域
        // pathRewrite:{'^/api':'/api'}            // 接口名重写
      },
      '/spis':{                                // 首页初期后端单体服务地址 废弃
        // target:'http://192.168.1.140:3000',   // 要代理的接口地址
        target:'http://183.129.167.74:7070',   // 要代理的接口地址
        // target:'http://192.168.1.200:7070',   // 要代理的接口地址
        changeOrigin:true,                            // 允许跨域
        pathRewrite:{'^/spis':''}            // 接口名重写
      },
      '/mall':{                                // 久鼎商城 启用
        target:'https://mobile.jiudingsupply.com',   // 正式地址
        // target:'http://47.97.170.21:7103/',   // 开发地址
        changeOrigin:true,                            // 允许跨域Ld-screen
        pathRewrite:{'^/mall':''}            // 接口名重写
      },
      '/tts':{                                // 能力中心单点登录接口 废弃
        target:'http://192.168.1.200:90',   // 要代理的接口地址
        changeOrigin:true,                            // 允许跨域
        pathRewrite:{'^/tts':''}            // 接口名重写
      },
      '/sle':{                                // 阿拉尔大屏
        target:'http://192.168.1.56:3233',   // 要代理的接口地址
        changeOrigin:true,                            // 允许跨域
        pathRewrite:{'^/sle':''}            // 接口名重写
      }
    },

    // Various Dev Server settings
    // host: '192.168.1.113', // gao
    host: '192.168.1.104', // HRCYD
    // host: '192.168.2.144', // home
    // host: '192.168.0.115', // home
    // host: 'localhost', // can be overwritten by process.env.HOST
    port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: true,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static-portal',
    assetsPublicPath: '/',

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 4